"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _NavigationAbout = _interopRequireDefault(require("./NavigationAbout"));

var _NavigationHowItWorks = _interopRequireDefault(require("./NavigationHowItWorks"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var NavigationWrapper = _styledComponents.default.div.attrs({
  "data-qa": "navigation-wrapper"
}).withConfig({
  displayName: "Navigation__NavigationWrapper",
  componentId: "sc-1ojz0vf-0"
})(["background-color:", ";justify-content:flex-end;padding:0 32px;display:none;@media (min-width:", "px){display:flex;height:40px;}"], function (props) {
  return props.theme.header.background;
}, function (props) {
  return props.theme.breakpoints.values.sm;
});

var NavigationMobileWrapper = _styledComponents.default.div.attrs({
  "data-qa": "navigation-mobile-wrapper"
}).withConfig({
  displayName: "Navigation__NavigationMobileWrapper",
  componentId: "sc-1ojz0vf-1"
})(["background-color:", ";display:flex;height:37px;justify-content:flex-end;padding:0 8px;@media (min-width:", "px){display:none;}"], function (props) {
  return props.theme.header.background;
}, function (props) {
  return props.theme.breakpoints.values.sm;
});

var ExtraSpaceForSupport = _styledComponents.default.div.attrs({
  "data-qa": "extra-space-for-support"
}).withConfig({
  displayName: "Navigation__ExtraSpaceForSupport",
  componentId: "sc-1ojz0vf-2"
})(["width:100px;"]);

var _ref2 = _react.default.createElement(_NavigationHowItWorks.default, null);

var _ref3 = _react.default.createElement(_NavigationAbout.default, null);

var _ref4 = _react.default.createElement(ExtraSpaceForSupport, null);

var _ref5 = _react.default.createElement(NavigationMobileWrapper, null);

var Navigation = function Navigation(_ref) {
  var shouldLoadPlugin = _ref.shouldLoadPlugin;
  return _react.default.createElement(_react.Fragment, null, _react.default.createElement(NavigationWrapper, null, _ref2, _ref3, shouldLoadPlugin ? _ref4 : null), _ref5);
};

Navigation.defaultProps = {
  shouldLoadPlugin: true
};
var _default = Navigation;
exports.default = _default;
module.exports = exports.default;